/* eslint-disable */
import createIcon from '../createIcon';

const IconInfoCircleFilled = createIcon({
  name: 'icon-info-circle-filled',
  content: '<path d="M512 64A448 448 0 1 1 512 960 448 448 0 0 1 512 64z m32 354.944h-64V768h64V418.944zM512 256a38.4 38.4 0 1 0-0.128 76.672A38.4 38.4 0 0 0 512 256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconInfoCircleFilled;
